"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_query_1 = require("react-query");
var render_app_1 = __importDefault(require("../../utils/render-app"));
var app_1 = __importDefault(require("./app"));
var queryClient = new react_query_1.QueryClient({
    defaultOptions: {
        queries: {
            staleTime: Infinity,
            refetchOnWindowFocus: false,
            refetchOnMount: false,
        },
    },
});
if (window.variantSelectorApp) {
    var _a = window.variantSelectorApp, product_1 = _a.product, modalSettings_1 = _a.modalSettings, nonShoppableSiteSettings_1 = _a.nonShoppableSiteSettings, pdpAddToCartSettings_1 = _a.pdpAddToCartSettings;
    (0, render_app_1.default)('variant-selector-app', function () { return (react_1.default.createElement(react_query_1.QueryClientProvider, { client: queryClient },
        react_1.default.createElement(app_1.default, { product: product_1, modalSettings: modalSettings_1, nonShoppableSiteSettings: nonShoppableSiteSettings_1, pdpAddToCartSettings: pdpAddToCartSettings_1 }))); });
}
